<template lang="pug">

    div
        .ui.checkbox
            input(
                type='checkbox'
                v-bind:id='id'
                v-model='model'
            )
            label(v-bind:for='id') {{ label }}

</template>

<script>
    import * as R from "ramda";

    export default {

        computed: {
            model: {
                get() { return R.prop(this.id, this.value) },
                set(value) { this.$emit('input', value) }
            }
        },

        props: {

            id: {
                type: String,
                required: true
            },

            label: {
                type: String,
                required: true
            },

            value: {
                required: true
            }

        }

    }

</script>
